export const Projects = [
  // Photo by ivan Torres on Unsplash
  {
    id: "c",
    name: "Fake Twitter",
    description: "In this imitation of the famous social network you can register (try it, it's quick and easy), you can create posts, mention other users, post images, visit user profiles, interact with other posts and more.",
    madeOf:"This WebApp was done using React.js fetching data from a server made on express.js. The server interacts with a SQL database and returns json data to the client. The UI look and feel was done using SASS, Chakra UI and FramerMotion. Various Javascript libraries were used as a complement such as: moment.js, Axios, Lodash, cloudinary, react-router, react-mentions and more... ",
    backgroundColor: "#959684",
    url:'https://faketwitter-front.vercel.app'
  },
  // Photo by Dennis Brendel on Unsplas
  {
    id: "f",
    name: "Mammo.com",

    description: "Sales of digital mammography machines, installation, service, parts supply, and training",
    madeOf:"This Web was done with the CMS made in php known as Joomla together with various technologies and frameworks such as: Javascript, Jquery, Bootstrap, Slick.js, Less, XML...",
    backgroundColor: "#959684",
    url:'https://www.mammo.com/'
  },
  // Photo by Alessandra Caretto on Unsplash
  {
    id: "g",
    name: "Suarez Physical Therapy Care.Experience",

    description: "Help and therapeutic assistance center located in Las Vegas. Dedicated to providing the Essential Support that their patients require through personalized physiotherapy.",
    madeOf:"This Web was done with the CMS made in php known as Joomla together with various technologies and frameworks such as: Javascript, Jquery, Bootstrap, Slick.js, Less, XML...",
    backgroundColor: "#959684",
    url:'https://suarezpt.com/'
  },
  {
    id: "b",
    name: "Drug Store",
    description: "In this Drug store example you can see a catalog of drugs and buy some pills",
    madeOf:"This WebApp was done using React.js fetching data from a server made on express.js. The server interacts with a SQL database and returns json data to the client. The UI look and feel was done using CSS and Bootstrap. Various Javascript libraries were used as a complement such as:  Axios, react-router, swalt and more... ",
    backgroundColor: "#959684",
    url:'https://drugstore-front-bzmzn64t9-romeran14.vercel.app/'
  },

  // Photo by Simone Hutsch on Unsplash https://www.washington-dental.com/
  {
    id: "e",
    name: "Pokedex",
    title: "Pokedex",
    description: "A usefull tool to search info about all pokemons. A classic exercise for them who are learning to use React.js",
    madeOf:"This WebApp was done using React.js fetching data from a PokeApi, Sass and Chakra UI for the styles, Chart.js was used to created a chart of the pokemon stadistics...",
    backgroundColor: "#959684",
    url:'https://pokedex-smoky-nine.vercel.app/'
  },
  // Photo by Siora Photography on Unsplash
  {
    id: "a",
    name: "CriptoApp",
    title: "CriptoApp",
    description: "A usefull tool to search info about Cryptos. This app show you the price of cryptos in live-time, also make Graphs about the currency history",
    madeOf:"This WebApp was done using React.js fetching data throught  Redux-Query from a RapidApi, AntDesing and some CSS for the styles, Chart.js was used to create charts",
    backgroundColor: "#959684",
    url:'https://cripto-steel.vercel.app/'
  },

];

export const openSpring = { type: "spring", stiffness: 200, damping: 30 };